import { formatMessage } from '@/utils/translationHelper';
import type { Locale } from '@/i18n';
import { ReactNode } from 'react';

// simple wrapper method to fetch translations for SEO Content
export function getSeoContent(locale: Locale, descriptionPhrase: string): string {
  return formatMessage(descriptionPhrase, locale, {
    h2: (chunks: ReactNode[]) =>
      `<h2
              class="text-neutral-90 md:text-d-xs/relaxed text-[18px]"
            >
              ${chunks}
            </h2>`,
    p: (chunks: ReactNode[]) =>
      `<p
              class="text-neutral-60 md:text-b-md/normal text-b-xs"
            >
              ${chunks}
            </p>`,
    c: (chunks: ReactNode[]) =>
      `<div
              class="flex flex-col gap-1"
            >
              ${chunks}
            </div>`
  });
}
